import React from "react";
import { Link, withRouter } from "react-router-dom";
import "./NotFound.scss";
import { useHistory } from 'react-router'
import miscUtils from "utils/miscUtils";
import { connect } from "react-redux";
import { Map } from "immutable";

interface INotFoundComponentProps {
  user: any;
  message: string | JSX.Element;
  subMessage?: string;
  showSubMessage?: boolean;
  group: any
  hideBoxShadow?: boolean;
  hideCardBorder?: boolean;
  errorCode?: number;
}

const NotFoundComponent = (props: INotFoundComponentProps) => {
  const history = useHistory();

  const navigate = () => {
    if (props.user) {
      window.open(`${miscUtils.getBaseDomain()}/creategroup`, "_self");
    } else {
      if (props.group) {
        history.push("/signup");
      } else {
        window.open(`${miscUtils.getBaseDomain()}/signup`, "_self");
      }
    }
  }
  
  const ErrorCodes = [429, 500]
  const reloadPage = () => {
     if (props.errorCode && ErrorCodes.includes(props.errorCode)) {
        window.location.reload()
     }
  }


  return <div className="not-found-container">
    <div className={`not-found-content ${props.hideBoxShadow ? 'box-shadow-none' : ''} ${props.hideCardBorder ? 'border-none' : ''}`}>
      <img src={require("./link.png")} alt="link" />
      {typeof props.message === "string" ? (
        <div className="heading">
          {
          props.errorCode === 429 ?
          <>
          Oops! Something went wrong. Please wait a moment before trying again.
          </>
          :
          <>
          {props.message}
          </>
}
          </div>
      ) : (
        <>
          {props.message}
        </>
      )}

      {
        props.showSubMessage &&
        <>
            {
              props.errorCode && !ErrorCodes.includes(props.errorCode)
              ?
          <p className="sub-heading">
              {props.subMessage  ?
                props.subMessage
                :
                <span>Create a community and make it yours.{" "}</span>
              }
            </p>
              :
              <></>
            }
          {
            props.errorCode && ErrorCodes.includes(props.errorCode)
              ?
              <button onClick={reloadPage} className="not-found-link-text">
                Reload the page
              </button>
              :
              <Link className="not-found-link-text"
                to="#"
                onClick={navigate}
              >
                {props.user ? "Create now!" : "Sign up now!"}
              </Link>
          }
        </>
      }
    </div>
  </div>;
}

const mapStateToProps = (state: Map<string, any>) => {
  const selectedGroup: string = state.getIn(["group", "selectedGroup"]) as string;

  return {
    group: selectedGroup,
  };
};

export default withRouter(
  connect(mapStateToProps, null)(NotFoundComponent as any) as any
) as any;
